import { render } from "./MetaTags.vue?vue&type=template&id=32ba809a"
import script from "./MetaTags.vue?vue&type=script&lang=js"
export * from "./MetaTags.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__